export const FETCH_SURVEY_USER_FORM_REQUEST = 'FETCH_SURVEY_USER_FORM_REQUEST';
export const FETCH_SURVEY_USER_FORM_SUCCESS = 'FETCH_SURVEY_USER_FORM_SUCCESS';
export const FETCH_SURVEY_USER_FORM_FAILURE = 'FETCH_SURVEY_USER_FORM_FAILURE';

export const SAVE_USER_ANSWERS_REQUEST = 'SAVE_USER_ANSWERS_REQUEST';
export const SAVE_USER_ANSWERS_SUCCESS = 'SAVE_USER_ANSWERS_SUCCESS';
export const SAVE_USER_ANSWERS_FAILURE = 'SAVE_USER_ANSWERS_FAILURE';

export const SEND_SURVEY_USER_FORM = 'SEND_SURVEY_USER_FORM';
export const SEND_SURVEY_USER_FORM_FAILD = 'SEND_SURVEY_USER_FORM_FAILD';